<template>
  <button class="border border-blue-600 bg-white hover:scale-105 active:scale-95 p-4 rounded-md mb-4 lg:mb-0 lg:w-52">
    <a :href="link" :target="target" :title="title" rel="noopener noreferrer">
      <span class="text-xl text-blue-600 lg:text-xl">{{ title }}</span>
    </a>
  </button>

</template>
<script>
export default {
  name: 'SecondaryButton',
  props: {
    title: {
      type: String,
      required: true
    },
    link: {
      type: String,
      required: true
    },
    target: {
      type: String,
      require: false
    }
  }
}
</script>